import React from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

const PdfPreviewModal = ({ open, pdfUrl, onClose }) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xl">
            <DialogTitle>Vista previa del PDF</DialogTitle>

            <DialogContent dividers sx={{ p: 0, height: "78vh" }}>
                {pdfUrl ? (
                    <iframe
                        src={pdfUrl}
                        title="Vista previa PDF"
                        width="100%"
                        height="100%"
                        style={{ border: "none" }}
                    />
                ) : (
                    <Box height="100%" display="flex" alignItems="center" justifyContent="center">
                        <Typography variant="body2" color="text.secondary">
                            Cargando PDF...
                        </Typography>
                    </Box>
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Cerrar</Button>
            </DialogActions>
        </Dialog>
    );
};

export default PdfPreviewModal;